import { extractTextFromQuery } from '../../../utils/query';
import { school_agencyName_$ilike_includes } from '../../../utils/query-helpers';

export default {
  param: extractTextFromQuery,
  having: function (text) {
    // const words = text.trim().split(' ');
    const words = text.trim();

    if (words) {
      return {
        site: {
          $where: {
            ...school_agencyName_$ilike_includes(words)
          }
        }
      };
    }
  }
}
